import { avoidAuthToken } from "./../../../../constants";
import optionConfigURL from "@adapters/infrastructures/urlConfig/Markets/optionsURL";
import { EOptionDrivingMarketSectionType, } from "@domains/features/Markets/Options/entites/drivingMarket";
import { OptionChainScreens, } from "@domains/features/Markets/Options/entites/iOptionChain";
import { fnoBanMapper } from "@domains/features/Markets/Common/mapper/fnoBan";
import { optionChainMapper } from "@domains/features/Markets/Options/mapper/optionChainMapper";
import { optionDrivingMarketMapper } from "@domains/features/Markets/Options/mapper/optionDrivingMarketMapper";
import { opRecommendationMapper } from "../../../../../domains/features/Markets/Options/mapper/opRecommendationMapper";
class OptionRepository {
    constructor(http) {
        this.http = http;
    }
    async getOptionChainData(req) {
        const url = new URL(`${optionConfigURL.optionTable}/${req.inst}/${req.symbol}/${req.expData}`);
        url.searchParams.append("screen", req.screen ? req.screen : OptionChainScreens.CHAIN);
        const optionChain = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
            avoidAuthToken,
        });
        return optionChainMapper(optionChain.data, req.screen ? req.screen : OptionChainScreens.CHAIN);
    }
    async getExpiryDateData() {
        const url = new URL(optionConfigURL.expiryDate);
        const expiryDate = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
            avoidAuthToken,
        });
        return expiryDate;
    }
    async getFnoBanData() {
        const url = new URL(optionConfigURL.fnoBan);
        const fnoBanData = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
            avoidAuthToken,
        });
        return fnoBanMapper(fnoBanData === null || fnoBanData === void 0 ? void 0 : fnoBanData.data);
    }
    async getOpRecommendationsData() {
        const url = new URL(optionConfigURL.recommendations);
        const opRecommendations = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
            avoidAuthToken,
        });
        return opRecommendationMapper(opRecommendations.data);
    }
    async getHighestGainerLoser(req) {
        const url = new URL(optionConfigURL.gainerLosers);
        url.searchParams.append("type", req.type);
        url.searchParams.append("period", req.period);
        const type = req.type === "loss"
            ? EOptionDrivingMarketSectionType.HIGHEST_OI_LOSER
            : EOptionDrivingMarketSectionType.HIGHEST_OI_GAINER;
        const highestGainer = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
            avoidAuthToken,
        });
        return optionDrivingMarketMapper(highestGainer.data, type, req.viewAll);
    }
    async getHighestOIData(req) {
        const url = new URL(optionConfigURL.highestOI);
        url.searchParams.append("period", req.period);
        const highestOI = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
            avoidAuthToken,
        });
        return optionDrivingMarketMapper(highestOI.data, EOptionDrivingMarketSectionType.HIGHEST_OI, req.viewAll);
    }
    async getHighestVolumeData(req) {
        const url = new URL(optionConfigURL.highestVolume);
        url.searchParams.append("period", req.period);
        const highestVolume = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
            avoidAuthToken,
        });
        return optionDrivingMarketMapper(highestVolume.data, EOptionDrivingMarketSectionType.HIGHEST_VOLUME, req.viewAll);
    }
}
export default OptionRepository;
